import React from 'react';
const intl = {
  headline: {
    'en': 'ABOUT US',
    'dk': 'OM OS',
  },
  block1: {
    headline: {
      'en': 'FOCUS',
      'dk': 'FOKUS',
    },
    subheadline: {
      'en': <div>Our focus is leadership development, <br/>but not in the traditional sense.</div>,
      'dk': 'Vores fokus er ledelsesudvikling, men ikke i traditionel forstand.'
    },
    body: {
      'en': <span>The consultants of iLEAD all have extensive experience in a variety of industries within both private and public sectors. We believe that groups, their collaboration, relationships and culture are key whenever organizations have to solve tasks, develop and achieve new goals.
        <br/><br/>
        In our experience this always starts with leadership and how the organization is enabled - and it manifest in the performance of groups and individuals. Look at our approach and see what we can do for you. 
      </span>,
      'dk': <span>iLEADs konsulenter dækker en bred vifte af komplimenterende uddannelser og har stor erfaring fra en række forskellige industrier inklusiv det offentlige. 
        <br/><br/>
        Vi mener grundlæggende at grupper, deres samarbejde og kultur er det vigtigste når organisationer skal løse opgaver, udvikle sig og nå nye mål. 
      </span>,
    },
    button: {
      'en': 'READ MORE',
      'dk': 'LÆS MERE',
    }
  },
  block5: {
    subheadline: {
      'en': 'LIFE IS ABOUT OPPORTUNITIES',
      'dk': 'LIVET HANDLER OM MULIGHEDER'
    },
    headline: {
      'en': <span>The opportunities around us are infinite. If only we dare to look for them, and have courage to do what it takes, whether it's change of direction, structure or event strategy. <br/><br/>
      Well, sometimes it's just ourselves we need to change!</span>,
      'dk': <span>Mulighederne omkring os er uendelige. Hvis vi tør kigge op og har modet til gøre det, der kræves. Uanset om det er at ændre retning, struktur – eller strategi! <br/><br/> og nogle gange er det 'bare' os selv der skal turde forandring!</span>
    }
  }
}

export default intl;


// WEBPACK FOOTER //
// ./src/pages/About/intl.js